// src/App.js
import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import AppLayout from './components/AppLayout';
import './styles/globals.css';

const App = () => {
  const [mapKitReady, setMapKitReady] = useState(false);

  useEffect(() => {
    console.log("App mounted or re-loaded"); // Logs on mount or hot reload

    const mapKitToken = process.env.REACT_APP_MAPKIT_TOKEN;

    // Check if the MapKit script is already present
    if (!document.querySelector('script[src="https://cdn.apple-mapkit.com/mk/5.x.x/mapkit.core.js"]')) {
      const script = document.createElement('script');
      script.src = "https://cdn.apple-mapkit.com/mk/5.x.x/mapkit.core.js";
      script.crossOrigin = "anonymous";
      script.async = true;
      script.dataset.callback = "initMapKit";
      script.dataset.libraries = "full-map,services";
      script.dataset.token = mapKitToken;

      script.onload = () => {
        setMapKitReady(true);
        console.log("MapKit script loaded");
      };

      document.head.appendChild(script);

      return () => {
        document.head.removeChild(script);
        console.log("MapKit script removed on component unmount");
      };
    } else {
      // MapKit script already exists, set ready state immediately
      setMapKitReady(true);
      console.log("MapKit script already loaded, skipping load");
    }
  }, []);

  if (!mapKitReady) {
    return <div className="loading-screen">Loading Map...</div>;
  }

  return (
    <Router>
      <Routes>
        <Route path="/" element={<AppLayout />} />
        {/* Add more routes here */}
      </Routes>
    </Router>
  );
};

export default App;
